function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 8a8 8 0 018-8h714a8 8 0 018 8v248H0V8z",
  fill: "#F2F5F7"
});
var _ref2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#ical-announcement-modal_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-276 46.508C-276 40.706-271.295 36-265.492 36H672.39c5.804 0 10.508 4.705 10.508 10.508v42.034H-276V46.508z",
  fill: "#F2F5F7"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.15,
  x: -92.102,
  y: 49.136,
  width: 128.729,
  height: 26.271,
  rx: 2.627,
  fill: "#A0AFBE"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.15,
  x: 565.01,
  y: 49,
  width: 34,
  height: 34,
  rx: 4.567,
  fill: "#A0AFBE"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.15,
  x: 475.01,
  y: 49,
  width: 34,
  height: 34,
  rx: 4.567,
  fill: "#A0AFBE"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.15,
  x: 430,
  y: 49,
  width: 34,
  height: 34,
  rx: 4.567,
  fill: "#A0AFBE"
}), /*#__PURE__*/React.createElement("rect", {
  opacity: 0.15,
  x: 520.01,
  y: 49,
  width: 34,
  height: 34,
  rx: 4.567,
  fill: "#A0AFBE"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.05,
  fill: "#0085FF",
  d: "M-276 121.381h958.898v72.246H-276z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M82.602 121.381h1.314v72.246h-1.314zM202.136 121.381h1.314v72.246h-1.314zM321.669 121.381h1.314v72.246h-1.314zM441.204 121.381h1.314v72.246h-1.314zM560.737 121.381h1.314v72.246h-1.314z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M-276 192.313h958.898v1.314H-276z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0085FF",
  d: "M-276 121.381h958.898v1.314H-276z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M-276 226.466h958.898v1.314H-276z"
}), /*#__PURE__*/React.createElement("g", {
  opacity: 0.65
}, /*#__PURE__*/React.createElement("rect", {
  x: 90.483,
  y: 127.949,
  width: 105.085,
  height: 26.271,
  rx: 1.314,
  fill: "#FCB154"
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.68,
  y: 134.517,
  width: 90.69,
  height: 3.941,
  rx: 1.314,
  fill: "#EAEEF2"
}), /*#__PURE__*/React.createElement("rect", {
  x: 97.68,
  y: 143.712,
  width: 48.944,
  height: 3.941,
  rx: 1.314,
  fill: "#EAEEF2"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.65
}, /*#__PURE__*/React.createElement("rect", {
  x: 449.085,
  y: 127.949,
  width: 105.085,
  height: 26.271,
  rx: 1.314,
  fill: "#1BC39F"
}), /*#__PURE__*/React.createElement("rect", {
  x: 456.283,
  y: 134.517,
  width: 90.69,
  height: 3.941,
  rx: 1.314,
  fill: "#EAEEF2"
}), /*#__PURE__*/React.createElement("rect", {
  x: 456.283,
  y: 143.712,
  width: 48.944,
  height: 3.941,
  rx: 1.314,
  fill: "#EAEEF2"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.65
}, /*#__PURE__*/React.createElement("rect", {
  x: 568.619,
  y: 127.949,
  width: 105.085,
  height: 26.271,
  rx: 1.314,
  fill: "#846CDF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 575.816,
  y: 134.517,
  width: 90.69,
  height: 3.941,
  rx: 1.314,
  fill: "#EAEEF2"
}), /*#__PURE__*/React.createElement("rect", {
  x: 575.816,
  y: 143.712,
  width: 48.944,
  height: 3.941,
  rx: 1.314,
  fill: "#EAEEF2"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.65
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillOpacity: 0.04,
  d: "M82.602 229.78h1.314v38.093h-1.314zM202.135 229.78h1.314v38.093h-1.314zM321.669 229.78h1.314v38.093h-1.314zM441.203 229.78h1.314v38.093h-1.314zM560.737 229.78h1.314v38.093h-1.314z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 218,
  y: 242,
  width: 84,
  height: 4,
  rx: 1,
  fill: "#846CDF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 218,
  y: 250,
  width: 46,
  height: 4,
  rx: 1,
  fill: "#846CDF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 212,
  y: 236,
  width: 103,
  height: 24,
  rx: 1,
  stroke: "#846CDF",
  strokeWidth: 2,
  strokeDasharray: "5 2"
}), /*#__PURE__*/React.createElement("rect", {
  x: 337,
  y: 242,
  width: 84,
  height: 4,
  rx: 1,
  fill: "#846CDF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 337,
  y: 250,
  width: 46,
  height: 4,
  rx: 1,
  fill: "#846CDF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 331,
  y: 236,
  width: 103,
  height: 24,
  rx: 1,
  stroke: "#846CDF",
  strokeWidth: 2,
  strokeDasharray: "5 2"
}), /*#__PURE__*/React.createElement("rect", {
  x: 456,
  y: 242,
  width: 84,
  height: 4,
  rx: 1,
  fill: "#846CDF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 456,
  y: 250,
  width: 46,
  height: 4,
  rx: 1,
  fill: "#846CDF"
}), /*#__PURE__*/React.createElement("rect", {
  x: 450,
  y: 236,
  width: 103,
  height: 24,
  rx: 1,
  stroke: "#846CDF",
  strokeWidth: 2,
  strokeDasharray: "5 2"
}), /*#__PURE__*/React.createElement("rect", {
  x: 569,
  y: 235,
  width: 105,
  height: 26,
  rx: 2,
  fill: "#D8D8D8"
}), /*#__PURE__*/React.createElement("rect", {
  x: 576,
  y: 242,
  width: 84,
  height: 4,
  rx: 1,
  fill: "#A0AFBE"
}), /*#__PURE__*/React.createElement("rect", {
  x: 576,
  y: 250,
  width: 46,
  height: 4,
  rx: 1,
  fill: "#A0AFBE"
}), /*#__PURE__*/React.createElement("rect", {
  x: -20,
  y: 242,
  width: 84,
  height: 4,
  rx: 1,
  fill: "#846CDF"
}), /*#__PURE__*/React.createElement("rect", {
  x: -20,
  y: 250,
  width: 46,
  height: 4,
  rx: 1,
  fill: "#846CDF"
}), /*#__PURE__*/React.createElement("rect", {
  x: -26,
  y: 236,
  width: 103,
  height: 24,
  rx: 1,
  stroke: "#846CDF",
  strokeWidth: 2,
  strokeDasharray: "5 2"
})), /*#__PURE__*/React.createElement("rect", {
  x: 619.721,
  y: 49.689,
  width: 32.5,
  height: 32.5,
  rx: 2.249,
  fill: "#fff",
  stroke: "#0085FF",
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M635.125 62.468h4.41v4.411M636.889 69.525h-4.411v-4.41",
  stroke: "#0085FF",
  strokeWidth: 1.676,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("rect", {
  x: 628.067,
  y: 58.057,
  width: 15.879,
  height: 15.879,
  rx: 0.838,
  stroke: "#0085FF",
  strokeWidth: 1.676,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M640.417 58.057v-2.646M631.596 58.057v-2.646",
  stroke: "#0085FF",
  strokeWidth: 1.676,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#0085FF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M655.509 46.241L659.751 42M653.26 45.749V39.75M656.259 48.748h5.999"
}), /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-.72675 .6869 -.72675 -.6869 617.943 84.196)",
  stroke: "#0085FF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M.75-.75h6.219"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#0085FF",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M620.28 85.749v5.999M617.194 82.75h-6.434"
}));
function SvgIcalAnnouncementModal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 730,
    height: 256,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "ical-announcement-modal_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 730,
    height: 256
  }, _ref), _ref2);
}
export default SvgIcalAnnouncementModal;